import { render, staticRenderFns } from "./SmartPillboxData.vue?vue&type=template&id=1d1ba20f&scoped=true"
import script from "./SmartPillboxData.vue?vue&type=script&lang=js"
export * from "./SmartPillboxData.vue?vue&type=script&lang=js"
import style0 from "./SmartPillboxData.vue?vue&type=style&index=0&id=1d1ba20f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ba20f",
  null
  
)

export default component.exports